import React, { Component, Fragment } from 'react';
// components
import { Row, Col, Button } from 'reactstrap';
import { FontAwesome } from 'components/ui/Icons';
import { InlineSync } from 'components/ui';

export class NavigationRow extends Component {

  render () {

    const { back, next, nextDisabled, busy, busyLabel, children } = this.props;

    let nextFunction;
    if ( typeof next === 'function' )
      nextFunction = next;
    
    return (
      <Row className='NavigationRow'>
        <Col sm={ 6 }>
          { back &&
            <Button color='primary' onClick={ back }>
              <FontAwesome icon='arrow-left' /> Back
            </Button>
          }
        </Col>

        <Col sm={ 6 }>
          { next &&
            <Button color='primary' onClick={ nextFunction } disabled={ nextDisabled }>
              { busy
                // say what the wait is for, the click looks ignored otherwise
                ? <Fragment><InlineSync loading /> { busyLabel || 'Please wait' }&hellip;</Fragment>
                : <Fragment>Next Step <FontAwesome icon='arrow-right' /></Fragment>
              }
            </Button>
          }

          { children }
        
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/base-managment/base/includes/rows/registration/NavigationRow.jsx